import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContainerReportData } from '../models/container-report-data.model';
import { ContainerReportFilter } from '../dtos/container-report-filter.dto';
import { ContainerReportDetail } from '../models/container-report-general.model';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private apiUrl = environment.apiUrl + environment.reportPath;

  constructor(private http: HttpClient) {}

  getReportContainer(filter: ContainerReportFilter): Observable<ContainerReportData[]> {
    return this.http.post<ContainerReportData[]>(this.apiUrl + '/container', filter);
  }

  getReportContainerTest(filter: ContainerReportFilter): Observable<ContainerReportData[]> {
    return this.http.post<ContainerReportData[]>(this.apiUrl + '/container-test', filter);
  }

  getReportContainerDetail(containerId: number): Observable<ContainerReportDetail> {
    return this.http.get<ContainerReportDetail>(this.apiUrl + `/container/macro/${containerId}`);
  }

  getReportContainerDetailPdf(containerId: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/pdf/container/macro/${containerId}`, {
      responseType: 'blob',
    });
  }

  // getReportContainerDetail(containerId: number): Observable<ContainerReportDetail> {
  //   return this.http.get<ContainerReportDetail>(`${this.apiUrl}/${containerId}/report-detail`);
  // }
}

// http://localhost:5268/Report/container/macro?Id=23
// http://localhost:5268/report/macro?Id=23
